export default "__VITE_ASSET__77b7accc__"